import NewProduct from '../../components/Proposal/NewProduct/NewProduct'
import WithProposalContainer from '../Common/WithProposalContainer'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'

NewProduct.fetchData = async ({ store, req, res, match }) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const props = {
  proposalType: PROPOSAL_TYPE.NEW_PRODUCT
}

const MappedContainer = WithProposalContainer(NewProduct, props)

export default MappedContainer
